const MONTH_NAMES = [
  "janeiro",
  "fevereiro",
  "março",
  "abril",
  "maio",
  "junho",
  "julho",
  "agosto",
  "setembro",
  "outubro",
  "novembro",
  "dezembro",
];

export function parseRevenueMonthDate(date: string): number {
  const parts = date.split("/");

  if (parts.length === 2) {
    const [month, year] = parts;
    const fullYear = year.length === 2 ? `20${year}` : year;
    return new Date(`${fullYear}-${month.padStart(2, "0")}-01`).getTime();
  }

  const [day, month, year] = parts;
  return new Date(`${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`).getTime();
}

export function formatRevenueMonthLabel(date: string): string {
  const parts = date.split("/");

  if (parts.length === 2) {
    const [month, year] = parts;
    const monthIndex = parseInt(month, 10) - 1;
    const monthName = MONTH_NAMES[monthIndex] ?? month;
    const displayYear = year.length === 2 ? `20${year}` : year;
    return `${monthName}/${displayYear}`;
  }

  const [, month, year] = parts;
  const monthIndex = parseInt(month, 10) - 1;
  const monthName = MONTH_NAMES[monthIndex] ?? month;
  return `${monthName}/${year}`;
}
